export const StorageKeys = {
  Token: 'cbs_token',
  RefreshToken: 'cbs_refresh_token',
  User: 'cbs_user',
  RememberMe: 'cbs_remember_me',
} as const;

export const ApiRoutes = {
  Auth: {
    Login: '/auth/login',
    Logout: '/auth/logout',
    Refresh: '/auth/refresh',
    Me: '/auth/me',
    Verify: '/auth/verify',
  },
  Clients: {
    List: '/clients',
    ById: (id: number) => `/clients/${id}`,
    Info: (id: number) => `/clients/${id}/info`,
    SearchByAccount: '/clients/search/by-account',
    SearchByPhone: '/clients/search/by-phone',
  },
  CDR: {
    List: '/cdr',
    Stats: '/cdr/stats',
  },
  Operators: {
    List: '/operators',
    Enabled: '/operators/enabled',
  },
  Stats: {
    CurrentDay: '/stats/calendar/current-day',
    CurrentMonth: '/stats/calendar/current-month',
  },
} as const;
